export const jobActions = {
  GET_JOB_OFFERS_PENDING: 'GET_JOB_OFFERS_PENDING',
  GET_JOB_OFFERS_SUCCESS: 'GET_JOB_OFFERS_SUCCESS',
  GET_JOB_OFFERS_ERROR: 'GET_JOB_OFFERS_ERROR',
};
